import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    viewLoading: false,
    status: null,
    response: null,
    workActivity: null,
    singleEmployer: null
}

export const getCandidateProfile = createAsyncThunk(
    "getCandidateProfile",
    async (id) => {
        try {
            const response = await instance.get(`/remark/candidate/fetch-profile?id=${id}`)
            return response.data;
        } catch (error) {
            throw error
        }
    }
)

export const updateCandidateProfile = createAsyncThunk(
    "updateCandidateProfile",
    async (body) => {
        try {
            const response = await instance.post(`/remark/candidate/update-candidate?id=${body.id}`, body.data)
            return response.data;
        } catch (error) {
            throw error
        }
    }
)

//candidate work-activity list---------->
export const candidateWorkActivity = createAsyncThunk(
    "candidateWorkActivity",
    async (body) => {
        try {
            const response = await instance.get(`/remark/candidate/fetch-candidate-work-activity?id=${body.id}`)
            return response.data;
        } catch (error) {
            throw error
        }
    }
)
//work-activity list---------->
//mail send candidate------> 
export const mailSendCandidate = createAsyncThunk(
    "mailSendCandidate",
    async (body) => {
        try {
            const response = await instance.post("/remark/email/send-mail-candidate", body)
            return response.data;
        } catch (error) {
            throw error
        }
    }
)

// Upload resume
export const uploadUserResume = createAsyncThunk(
    "uploadUserResume",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await fetch(
                "https://testapi.remarkhr.com/employees/update-resume-for-crm",
                {
                    method: "POST",
                    body: formData,
                }
            );

            const data = await response.json();

            if (!response.ok) {
                return rejectWithValue(data);
            }

            return data;
        } catch (error) {
            return rejectWithValue({ message: error.message });
        }
    }
);


// {customer supporrt  user activity}
export const addCustomerSupportUserActivity = createAsyncThunk(
    "addCustomerSupportUserActivity",
    async (body) => {
        try {

            const response = await instance.post("/crm/customer-support/insert-cs-user-activity", body);
            return response.data;
        } catch (error) {
            throw error
        }
    }
)
export const CandidateSlice = createSlice({
    name: "CandidateSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getCandidateProfile.pending, (state, action) => {
            state.loading = true;
            state.response = null;
            state.data = null;
        });
        builder.addCase(getCandidateProfile.fulfilled, (state, action) => {
            state.loading = false;
            state.status = action.payload.status;
            state.data = action.payload;
        });
        builder.addCase(getCandidateProfile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        builder.addCase(updateCandidateProfile.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(updateCandidateProfile.fulfilled, (state, action) => {
            state.loading = false;
            state.status = action.payload.status;
            state.response = action.payload;
        });
        builder.addCase(updateCandidateProfile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Upload  user Resume
        builder.addCase(uploadUserResume.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(uploadUserResume.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(uploadUserResume.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        builder.addCase(candidateWorkActivity.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(candidateWorkActivity.fulfilled, (state, action) => {
            state.loading = false;
            state.status = action.payload.status;
            state.workActivity = action.payload;
        });
        builder.addCase(candidateWorkActivity.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        // builder.addCase(addCustomerSupportUserActivity.pending, (state, action) => {
        //     state.viewLoading = true;
        // });
        // builder.addCase(addCustomerSupportUserActivity.fulfilled, (state, action) => {
        //     state.viewLoading = false;
        //     state.response = action.payload;
        // });
        // builder.addCase(addCustomerSupportUserActivity.rejected, (state, action) => {
        //     state.viewLoading = false;
        //     state.error = action.payload;
        // })


    }
})

export default CandidateSlice.reducer;